import { render, staticRenderFns } from "./PortalSelect.vue?vue&type=template&id=119b91ca&scoped=true&"
import script from "./PortalSelect.vue?vue&type=script&lang=ts&"
export * from "./PortalSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PortalSelect.vue?vue&type=style&index=0&id=119b91ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b91ca",
  null
  
)

export default component.exports